/**
 * @file index.tsx
 *
 * @fileoverview Shows a text for description.
 */
import React from "react";
import styles from "./formDescription.module.scss";
import { WYSIWYGText } from "./../../../13-text/02-WYSIWYG";

interface FormDescriptionProps {
  /**
   * Content to display inside a FULL HTML placeholder.
   */
  content?: string;
  /**
   * Children to display after the HTML content.
   */
  children?: React.ReactNode;
}

export function FormDescription({
  content,
  children = null,
}: FormDescriptionProps) {
  return (
    <div className={styles.formDescription}>
      {content && <WYSIWYGText format="full_html" content={content} />}
      {children}
    </div>
  );
}
